// extracted by mini-css-extract-plugin
export default {"root":"_3i0Iq","link-overlay":"_2BhGS","linkOverlay":"_2BhGS"};